import { render, staticRenderFns } from "./save-cancel-buttons.vue?vue&type=template&id=69df1e06&"
import script from "./save-cancel-buttons.vue?vue&type=script&lang=ts&"
export * from "./save-cancel-buttons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports